var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { staticClass: "upload-modal" },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.$ct("upload-documents"))),
          _c("w-spacer"),
          _c(
            "w-link",
            {
              attrs: { white: "" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "times" } })],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-content",
        [
          !_vm.sending
            ? [
                _c(
                  "app-file-upload",
                  {
                    attrs: {
                      multiple: "",
                      "allowed-extensions": _vm.allowedExtensions,
                      "max-size": _vm.maxSize,
                    },
                    on: {
                      input: function ($event) {
                        return _vm.addFile($event)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "drop upload-drop" },
                      [
                        _c("w-fa", {
                          staticClass: "drop-icon",
                          attrs: { icon: "cloud-upload-alt" },
                        }),
                        _c("div", [_vm._v(_vm._s(_vm.$ct("drop-files-here")))]),
                        _c("div", { staticClass: "drop-hint" }, [
                          _vm._v(_vm._s(_vm.$ct("allowed-file-types"))),
                        ]),
                      ],
                      1
                    ),
                  ]
                ),
                _vm.files.length
                  ? [
                      _c(
                        "div",
                        { staticClass: "file-list-head" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$ct("selected-files", {
                                  count: _vm.files.length,
                                })
                              ) +
                              " "
                          ),
                          _c("w-spacer"),
                          _c(
                            "w-link",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.clearFiles()
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$ct("clear-all")))]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "file-list" },
                        _vm._l(_vm.files, function (file, i) {
                          return _c(
                            "div",
                            {
                              key: file.name + "-" + file.size,
                              staticClass: "file-row",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "file-badge",
                                  class: _vm.fileKind(file),
                                },
                                [
                                  _c("w-fa", {
                                    attrs: { icon: _vm.fileIcon(file) },
                                  }),
                                ],
                                1
                              ),
                              _c("span", { staticClass: "file-info" }, [
                                _c("span", { staticClass: "file-name" }, [
                                  _vm._v(_vm._s(file.name)),
                                ]),
                                _c("span", { staticClass: "file-size" }, [
                                  _vm._v(_vm._s(_vm.prettySize(file.size))),
                                ]),
                              ]),
                              _c(
                                "w-link",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: _vm.$t("common.delete"),
                                      expression: "$t('common.delete')",
                                    },
                                  ],
                                  staticClass: "file-remove",
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeFile(i)
                                    },
                                  },
                                },
                                [_c("w-fa", { attrs: { icon: "times" } })],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ]
                  : _vm._e(),
              ]
            : _c(
                "div",
                { staticClass: "uploading" },
                [
                  _c("app-upload-scan-animation", {
                    attrs: {
                      text: _vm.$ct("uploading-percent", {
                        percent: _vm.uploadJob.uploadPercent,
                      }),
                    },
                  }),
                  _c("w-progress-linear", {
                    attrs: {
                      color: "var(--main-blue-3)",
                      value: _vm.uploadJob.uploadPercent,
                    },
                  }),
                ],
                1
              ),
        ],
        2
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("common.close")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { disabled: !_vm.files.length || _vm.sending },
              on: {
                click: function ($event) {
                  return _vm.upload()
                },
              },
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.$ct("upload-count", { count: _vm.files.length })) +
                  " "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }